import { Component, ViewEncapsulation } from '@angular/core';
import { BaseBPProfilesDetailComponent } from '../base-bp-profiles-detail.component';
import { Override } from '../../../../shared/app-decorators';
import { BPProfilesService } from '../../bp-profiles.service';
import { BPProfilesTerritoriesDataService, ITerritory } from '../territories/bp-profiles-territories-data.service';
import { BPProfilesSLADataService, IProfileSLA, IProfileSLAResponse } from './bp-profiles-sla-data.service';
import { Dictionary } from '../../../../../type_definitions/vendor';
import { util } from '../../../../shared/util';
import { BPProfilesSLAService } from './bp-profiles-sla.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { FormattingService } from '../../../../shared/services/formatting.service';
import * as _ from 'underscore';

interface ISLAFormModel {
  territory?:ITerritory;
}

@Component({
  selector: 'bp-profiles-sla',
  template: `
    <!-- selected country filter form -->
    <formly [form]="form" [fields]="fields" [model]="model"></formly>

    <div class="d-block margin-top-sm">
      <h2 *ngIf="loading">
        <activity-indicator></activity-indicator>
      </h2>

      <div class="d-block" *ngIf="!loading">
        <div class="profile-attribute-wrapper" *ngFor="let group of profileSLA | keyvalue: orderKeyValue">
          <h4 class="sla-group-title">{{ group.key | translate }}</h4>
          <bp-profiles-sla-definitions [(slaDefinitions)]="group.value.slaDefinitions" [editingMode]="editingMode"></bp-profiles-sla-definitions>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./bp-profiles-sla.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BPProfilesSLAComponent extends BaseBPProfilesDetailComponent {
  public model:ISLAFormModel = {};
  public editingMode:boolean;
  public profileSLA:Dictionary<IProfileSLA>;

  private backupSLAData:IProfileSLAResponse;
  private territoryField:IExtraFieldConfigurationObject;

  constructor(
    private formattingService:FormattingService,
    private formlyService:GaFormlyService,
    private bpProfilesTerritoriesDataService:BPProfilesTerritoriesDataService,
    private bpProfilesSLADataService:BPProfilesSLADataService,
    private bpProfilesSLAService:BPProfilesSLAService,
    protected bpProfilesService:BPProfilesService
  ) {
    super(bpProfilesService);
  }

  @Override(BaseBPProfilesDetailComponent)
  public ngOnInit():void {
    this.fields = this.createFields();
    this.fillFields();
    // register listener
    this.listen();
  }

  @Override(BaseBPProfilesDetailComponent)
  public resetModel():void {
    this.profileSLA = this.bpProfilesSLAService.processSLA(this.backupSLAData);
  }

  @Override(BaseBPProfilesDetailComponent)
  public onEditChange(isEdit:boolean) {
    this.editingMode = isEdit;
    if (!isEdit) {
      this.resetModel();
    }
  }

  public orderKeyValue():number {
    // preserve original order of key values
    return 0;
  }

  protected createFields():IExtraFieldConfigurationObject[] {
    const fullWidthClass:string = 'col-sm-12';
    return [
      this.formlyService.aValue('extraInfo')
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .withGroupClass('sla-extra-info')
        .showInfo()
        .build(),
      this.territoryField = this.formlyService.aSelect2('territory')
        .withFormat((territory:ITerritory) => this.formattingService.formatCountry(territory.country))
        .withLabelClass(fullWidthClass)
        .withValueClass(fullWidthClass)
        .hidePlaceholder()
        .onChange(this.onTerritoryChange)
        .build()
    ];
  }

  protected fillFields():void {
    this.formlyService.fillField(
      this.territoryField,
      this.bpProfilesTerritoriesDataService.getTerritories(this.bpProfilesService.activeProfile?.id)
        .then((territories:ITerritory[]) => {
          if (this.territoryField) {
            this.territoryField.formControl.setValue(_.find(territories, (territory:ITerritory) => territory.country?.id === this.bpProfilesService.activeProfile?.country?.id));
          }
          return territories;
        })
    );
  }

  private onTerritoryChange = ():void => {
    if (util.notNullOrUndefinedOrEmpty(this.model.territory)) {
      this.loading = true;
      this.bpProfilesSLADataService.getSLA(this.bpProfilesService.activeProfile?.id, this.model.territory?.country?.id)
        .then(this.onSLADataLoaded)
        .finally(() => {
          this.loading = false;
        });
    } else {
      // clear profile SLA
     this.profileSLA = {};
    }
  };

  private onSLADataLoaded = (response:IProfileSLAResponse) => {
    this.backupSLAData = util.copyAndExtend(response);
    this.profileSLA = this.bpProfilesSLAService.processSLA(response);
    return response;
  };

  protected onSave = ():void => {
    // we only save if user selected territory
    // else we do nothing
    if (util.notNullOrUndefinedOrEmpty(this.model.territory)) {
      const profileId:number = this.bpProfilesService.activeProfile?.id;
      const countryId:number = this.model.territory?.country?.id;
      const requestData:IProfileSLA[] = this.bpProfilesSLAService.createSLARequestData(this.profileSLA, this.backupSLAData);

      this.setSaveBusy(true);
      this.bpProfilesSLADataService.saveSLA(profileId, countryId, requestData)
        .then(this.onSLADataLoaded)
        .catch(this.emitErrorSaving)
        .finally(() => {
          this.setSaveBusy(false);
        });
    }
  };
}